import React from "react";
import { COMPANY_NAME } from "../../../constants";
import BrowserHistoryHelper from "../../../util/BrowserHistoryHelper";
import AuthViewModel from "../../view-model/auth/AuthViewModel";
import BaseView from "../BaseView";
import LoadingComponent from "../../../util/component/LoadingComponent";

interface Props {
  authViewModel: AuthViewModel;
}

interface State {
  emailQuery: string;
  passwordQuery: string;

  isEmailError: boolean;
  isPasswordError: boolean;
  loginError: string;

  isLoading: boolean;
}

export default class LoginComponent extends React.Component<Props, State> implements BaseView {
  private authViewModel: AuthViewModel;

  public constructor(props: Props) {
    super(props);
    this.authViewModel = props.authViewModel;

    this.state = {
      emailQuery: this.authViewModel.emailQuery,
      passwordQuery: this.authViewModel.passwordQuery,

      isEmailError: this.authViewModel.isEmailError,
      isPasswordError: this.authViewModel.isPasswordError,
      loginError: this.authViewModel.loginError,

      isLoading: this.authViewModel.isLoading,
    };
  }

  public componentDidMount = (): void => {
    this.authViewModel.attachView(this);
  };

  public componentWillUnmount = (): void => {
    this.authViewModel.detachView(this);
  };

  public onViewModelChanged = (): void => {
    this.setState({
      emailQuery: this.authViewModel.emailQuery,
      passwordQuery: this.authViewModel.passwordQuery,

      isEmailError: this.authViewModel.isEmailError,
      isPasswordError: this.authViewModel.isPasswordError,
      loginError: this.authViewModel.loginError,

      isLoading: this.authViewModel.isLoading,
    });
  };

  public render = (): JSX.Element => {
    const {
      emailQuery,
      passwordQuery,

      isEmailError,
      isPasswordError,
      loginError,

      isLoading,
    } = this.state;

    return (
      <div id="login-page" className="container-fluid">
        <div className="row justify-content-center">
          <div className="col login-inner bg-white">
            <div className="row justify-content-center">
              <h5
                className="font-weight-bold text-white px-5 py-3 text-center"
                style={{ background: "#28a745", marginTop: "70px", minWidth: "300px" }}
              >
                {COMPANY_NAME}
              </h5>
            </div>

            <div className="row justify-content-center mt-2">
              <span className="font-weight-bold" style={{ fontSize: "19px" }}>
                Log in to your account
              </span>
            </div>

            <div className="row justify-content-center mt-5">
              <div className="col-9">
                <div className="row">
                  <input
                    type="text"
                    placeholder="your.email@mail.com"
                    className={`form-control ${isEmailError ? "error-border" : ""}`}
                    value={emailQuery}
                    onChange={(e) => this.authViewModel.onEmailQueryChanged(e.target.value)}
                  />
                </div>

                <div className="row mt-2">
                  <input
                    type="password"
                    placeholder="Password"
                    className={`form-control ${isPasswordError ? "error-border" : ""}`}
                    value={passwordQuery}
                    onChange={(e) => this.authViewModel.onPasswordQueryChanged(e.target.value)}
                  />
                </div>

                {isEmailError && (
                  <div className="row mt-3 justify-content-center text-center">
                    <span className="text-danger" style={{ maxWidth: "280px" }}>
                      Email is not valid
                    </span>
                  </div>
                )}

                {isPasswordError && (
                  <div className="row mt-3 justify-content-center text-center">
                    <span className="text-danger" style={{ maxWidth: "280px" }}>
                      Password is empty
                    </span>
                  </div>
                )}

                {loginError && !isEmailError && !isPasswordError && (
                  <div className="row mt-3 justify-content-center text-center">
                    <span className="text-danger" style={{ maxWidth: "280px" }}>
                      {loginError}
                    </span>
                  </div>
                )}

                <div className="row mt-3 justify-content-center">
                  <button
                    type="button"
                    className="btn btn-success px-5 w-100 text-white d-flex align-items-center justify-content-center"
                    onClick={(): void => this.authViewModel.onSignIn()}
                    disabled={isLoading}
                    style={{ height: "38px" }}
                  >
                    {isLoading ? <LoadingComponent color="light" size="xs" /> : "Log in"}
                  </button>
                </div>

                <div className="row mt-2 justify-content-center">
                  <button
                    type="button"
                    className="btn btn-link btm-sm text-success px-5 w-100"
                    onClick={(): void => BrowserHistoryHelper.moveTo("/forgot-password")}
                  >
                    Forgot password?
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
}
